import React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./List";
import Add from "./Add";
import Summary from "./Summary";
import StockReceipt from "./StockReceipt";
import CustomerOrderAdd from "./CustomerOrderAdd";
import ReceiptDetails from "./recieptDetails";

function PurchaseOrders({ match }) {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/add`} component={Add} />
      <Route path={`${path}/customer-order-add`} component={CustomerOrderAdd} />
      <Route path={`${path}/:id/summary`} component={Summary} />
      <Route path={`${path}/:id/edit`} component={Summary} />
      <Route path={`${path}/:id/receipt-details`} component={ReceiptDetails} />
    </Switch>
  );
}

export { PurchaseOrders };
